import React, { PropTypes } from 'react'

function ProductTemplate(props) {
	return (
		<div>{props.children}</div>
	)
}

export default ProductTemplate



// WEBPACK FOOTER //
// ./products/_template.js